import { render, staticRenderFns } from "./laborSet.vue?vue&type=template&id=78d9547c&scoped=true&"
import script from "./laborSet.vue?vue&type=script&lang=js&"
export * from "./laborSet.vue?vue&type=script&lang=js&"
import style0 from "./laborSet.vue?vue&type=style&index=0&id=78d9547c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d9547c",
  null
  
)

export default component.exports